module.exports = __webpack_public_path__ + "img/icon-driedflower.0182c6eb.svg";